import React, { useMemo } from 'react';
import Carousel from 'react-multi-carousel';
import 'react-multi-carousel/lib/styles.css';
import { featuresList, responsive } from './helpers';
import SectionRow from '../SectionRow';
import './styles.scss';
import NextButton from '../NextButton';

// Flatten original 2D structure to keep backward compatibility with data definition
const flattenFeatures = (list) => list.reduce((acc, curr) => acc.concat(curr), []);

const Features = () => {
  const flatFeatures = useMemo(() => flattenFeatures(featuresList), []);

  const FeatureItem = ({ imgPath, title }) => (
    <div className="col-md col-12 text-center">
      <div className="icon-box mx-auto">
        <img src={imgPath} className="icon-img" alt={title} />
      </div>
      <p className="gray-text mt-3 mb-0">{title}</p>
    </div>
  );

  return (
    <>
      <div className="container generic-padding-carousel landing-scroll" id="features">
        <div className="row text-center pading-carousel-title">
          <div className="col">
            <h2 className="gray-text landing-section-title">¿Qué incluye el servicio cambio de aceite?</h2>
            <p className="gray-text fs-2">Cada cambio de aceite incluye la revisión de:</p>
          </div>
        </div>
        <Carousel
          swipeable={false}
          draggable={false}
          showDots={false}
          responsive={responsive}
          ssr
          infinite
          autoPlay
          autoPlaySpeed={5000}
          keyBoardControl
          transitionDuration={500}
          containerClass="react-multi-carousel-size"
          dotListClass="custom-dot-list-style"
          itemClass="carousel-item-padding-40-px"
        >
          {flatFeatures.map((data, index) => (
            <div key={index} className="px-2">
              <SectionRow>
                <FeatureItem imgPath={data.image} title={data.title} />
              </SectionRow>
            </div>
          ))}
        </Carousel>
      </div>
  <NextButton arrowColor='redArrow' sectionId='#steps' offset='features' />
    </>
  );
};

export default Features;
